import { useMutation } from 'react-query';
import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';
import { useNotificationStore } from '@/stores/notifications';
import { showNotification } from '@/utils/notificationUtils';

export type requestDTO = {

    id?: number | string;
    name:any;
    address: string;
    gstNumber?: string;

};

export const updateInstitute = ({ id, name,address, gstNumber}: requestDTO) => {
        return axios.post(`/superadmin/update-institut-details`, {id,  name,address, gstNumber});
};

type UseAddUserOptions = {
  config?: MutationConfig<typeof updateInstitute>;
};

export const useUpdateInstitute = ({ config }: UseAddUserOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    onSuccess: () => {
      showNotification({
        type: 'success',
        title: 'Institute updated successfully',
      });
    },
    ...config,
    mutationFn: updateInstitute,
  });
};
